"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from "react";
import { useMergedRef } from "../../hooks";
import { Tooltip } from "../Tooltip";
import { Truncate } from "../Truncate";
import { getIsOverflowed } from "./utils";
/**
 * Renders a tooltip with the full text if the text overflows.
 */
export function TextOverflowTooltip(t0) {
  const $ = _c(18);
  let children;
  let content;
  let disabled;
  let overrides;
  let ref;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      content,
      disabled,
      overrides,
      ref,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = content;
    $[3] = disabled;
    $[4] = overrides;
    $[5] = ref;
    $[6] = rest;
  } else {
    children = $[1];
    content = $[2];
    disabled = $[3];
    overrides = $[4];
    ref = $[5];
    rest = $[6];
  }
  const [overflowed, setOverflowed] = useState(false);
  const containerRef = useRef(null);
  const mergedRef = useMergedRef(ref, containerRef);
  const t1 = content || children;
  const t2 = disabled || !overflowed;
  const t3 = overrides?.Tooltip;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const isOverflowed = getIsOverflowed(containerRef?.current);
      setOverflowed(isOverflowed);
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = overflowed ? 0 : -1;
  let t6;
  if ($[8] !== children || $[9] !== mergedRef || $[10] !== rest || $[11] !== t5) {
    t6 = <Truncate onMouseOver={t4} ref={mergedRef} tabIndex={t5} {...rest}>{children}</Truncate>;
    $[8] = children;
    $[9] = mergedRef;
    $[10] = rest;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t3 || $[16] !== t6) {
    t7 = <Tooltip content={t1} disabled={t2} {...t3}>{t6}</Tooltip>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}